module.exports = __webpack_public_path__ + "img/05.965829f4.png";